import styled from '@emotion/styled';
import Button from 'aquilla/core/molecules/Button';
import { Dialog } from 'aquilla/core/molecules/Dialog';
import { mediaQuery, Spacings } from '@styles/index';
import Image from '@base/FutureImage';
import Typography from 'aquilla/core/atoms/Typography';
import CheckContained from 'aquilla/icons/misc/CheckContained';
import NotesPdf from 'aquilla/icons/misc/NotesPdf';
import Close from 'aquilla/icons/actions/Close';
import IconButton from 'aquilla/core/molecules/IconButton';

const Container = styled.div``;
const StyledDialog = styled(Dialog)`
  width: 328px;
  height: auto;
  padding: 0 ${Spacings.SPACING_6B};
  gap: ${Spacings.SPACING_4B};
  position: relative;
  overflow: visible;
  ${mediaQuery.uptoMobile} {
    height: auto;
    width: 328px;
    padding: ${Spacings.SPACING_4B};
  }
`;
const HeaderAnimationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_4B};
  margin-bottom: ${Spacings.SPACING_4B};
`;

// const StyledImage = styled(Image)``;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_4B};
`;

const StyledButton = styled(Button)`
  width: 296px;
  height: 48px;
`;

const DialogWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const DialogHeader = styled.div``;
const DialogSubHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_3B};
`;

const DialogSubHeader = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${Spacings.SPACING_2B};
`;
const ImageWrapper = styled.div`
  border-bottom: 1px solid var(--color-i-divider);
`;

const CrossButton = styled(IconButton)`
  border-radius: 24px;
  width: 48px;
  height: 48px;
  align-self: center;
  position: absolute;
  bottom: -48px;
  transform: translateY(100%);
  svg {
    color: var(--color-base-1);
  }
`;

const DownloadAppDialog = ({ isOpen, onClose, downloadApp, onNotesClick }) => {
  const onCloseDialogBox = () => {
    if (typeof onClose === 'function') onClose();
  };

  const onClickDownload = () => {
    if (typeof downloadApp === 'function') downloadApp();
  };
  const onClassNotesClick = () => {
    if (typeof onNotesClick === 'function') onNotesClick();
  };

  return (
    <Container>
      <StyledDialog open={isOpen} close={onCloseDialogBox}>
        <DialogWrapper>
          <HeaderAnimationWrapper>
            <DialogHeader>
              <Typography variant="h3">
                Download app to watch unlimited free classes
              </Typography>
            </DialogHeader>
            <ImageWrapper>
              <Image
                src="NewAppDownload.svg"
                height={202}
                width={272}
                alt="Download Nudge"
              />
            </ImageWrapper>
          </HeaderAnimationWrapper>
          <DialogSubHeaderWrapper>
            <DialogSubHeader>
              <CheckContained height={20} width={20} />
              <Typography variant="p2">
                {' '}
                Fully organized study planner
              </Typography>
            </DialogSubHeader>
            <DialogSubHeader>
              <CheckContained height={20} width={20} />
              <Typography variant="p2">
                Exceptional educators to learn from
              </Typography>
            </DialogSubHeader>
            <DialogSubHeader>
              <CheckContained height={20} width={20} />
              <Typography variant="p2">
                Mock tests, live quizzes & practice
              </Typography>
            </DialogSubHeader>
          </DialogSubHeaderWrapper>
        </DialogWrapper>
        <ButtonWrapper>
          <StyledButton variant="primary" onClick={onClickDownload}>
            Download the app
          </StyledButton>
          <StyledButton
            variant="secondary"
            onClick={onClassNotesClick}
            startIcon={<NotesPdf height={24} width={24} />}
          >
            Class notes
          </StyledButton>
        </ButtonWrapper>
        <CrossButton variant="primary" isIconButton onClick={onCloseDialogBox}>
          <Close size={48} />
        </CrossButton>
      </StyledDialog>
    </Container>
  );
};

export default DownloadAppDialog;
